import { render } from "./Searchbar.vue?vue&type=template&id=481b43f0&scoped=true"
import script from "./Searchbar.vue?vue&type=script&lang=js"
export * from "./Searchbar.vue?vue&type=script&lang=js"

import "./Searchbar.vue?vue&type=style&index=0&id=481b43f0&scoped=true&lang=css"

import exportComponent from "/Users/warths/refonte-manager-cli/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481b43f0"]])

export default __exports__